'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 }),
  (exports.default = void 0);
var _templateObject,
  _react = _interopRequireDefault(require('react')),
  _styledComponents = _interopRequireDefault(require('styled-components')),
  _propTypes = _interopRequireDefault(require('prop-types')),
  _utilities = require('@vds-core/utilities'),
  _color = require('@vds-tokens/color');
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : { default: e };
}
function _taggedTemplateLiteral(e, t) {
  return (
    t || (t = e.slice(0)),
    Object.freeze(
      Object.defineProperties(e, { raw: { value: Object.freeze(t) } })
    )
  );
}
var propTypes = {
    size: _propTypes.default.oneOfType([
      _propTypes.default.oneOf(['small', 'medium', 'large', 'XLarge']),
      _propTypes.default.string,
      _propTypes.default.number,
    ]),
    color: _propTypes.default.oneOf([
      '#000000',
      '#FFFFFF',
      '#ffffff',
      '#EE0000',
      '#ee0000',
      '#F6F6F6',
      '#f6f6f6',
      '#D8DADA',
      '#d8dada',
      '#A7A7A7',
      '#a7a7a7',
      '#6F7171',
      '#6f7171',
      '#333333',
      '#1B1D1F',
      '#1b1d1f',
      '#ffece0',
      '#FFECE0',
      '#ffcaaa',
      '#FFCAAA',
      '#ffa46d',
      '#FFA46D',
      '#ff8027',
      '#FF8027',
      '#b95319',
      '#B95319',
      '#732706',
      '#561701',
      '#fff9de',
      '#FFF9DE',
      '#fff4bc',
      '#FFF4BC',
      '#ffe97a',
      '#FFE97A',
      '#fed60e',
      '#FED60E',
      '#bc9f0a',
      '#BC9f0A',
      '#635305',
      '#4b3f04',
      '#4B3F04',
      '#e3f2fd',
      '#E3F2FD',
      '#aad8f9',
      '#AAD8F9',
      '#4aabf2',
      '#4AABF2',
      '#0089ec',
      '#0089EC',
      '#006fc1',
      '#006FC1',
      '#003e6c',
      '#003E6C',
      '#002c4d',
      '#002C4D',
      '#dcf5e6',
      '#DCF5E6',
      '#a4e6bd',
      '#A4E6BD',
      '#63d48e',
      '#63D48E',
      '#00b845',
      '#00B845',
      '#008331',
      '#004b1c',
      '#004B1C',
      '#003514',
      '#febfe8',
      '#FEBFE8',
      '#fc89d5',
      '#FC89D5',
      '#fb42bc',
      '#FB42BC',
      '#b9318b',
      '#B9318B',
      '#671b4e',
      '#671B4E',
      '#edb9fb',
      '#EDB9FB',
      '#e084f9',
      '#E084F9',
      '#ce3df5',
      '#CE3DF5',
      '#84279e',
      '#84279E',
      '#461553',
      '#FBE4D7',
      '#fbe4d7',
      '#ED7000',
      '#ed7000',
      '#C44904',
      '#c44904',
      '#4A1C02',
      '#4a1c02',
      '#FFF4E0',
      '#fff4e0',
      '#FFBC3D',
      '#ffbc3d',
      '#523C14',
      '#523c14',
      '#D6EEFB',
      '#d6eefb',
      '#0096E4',
      '#0096e4',
      '#0077B4',
      '#0077b4',
      '#002B42',
      '#002b42',
      '#D6F2E0',
      '#d6f2e0',
      '#00AC3E',
      '#00ac3e',
      '#008330',
      '#003614',
    ]),
    surface: _propTypes.default.oneOf(['light', 'dark']),
    id: _propTypes.default.string,
    ariaHidden: _propTypes.default.bool,
    ariaLabel: _propTypes.default.string,
  },
  defaultProps = {
    size: 'medium',
    color: _color.ColorTokens.elements.primary.onlight.value,
    surface: 'light',
    ariaHidden: !1,
  },
  StyledSVG = _styledComponents.default.svg(
    _templateObject ||
      (_templateObject = _taggedTemplateLiteral([
        '\n  display: inline-block;\n  height: ',
        ';\n  width: ',
        ';\n  min-height: ',
        ';\n  min-width: ',
        ';\n  &:active,\n  &:focus {\n    outline: none;\n  }\n',
      ])),
    function(e) {
      var t = e.iconHeight;
      return (0, _utilities.calculateRem)(t);
    },
    function(e) {
      var t = e.iconWidth;
      return (0, _utilities.calculateRem)(t);
    },
    function(e) {
      var t = e.iconHeight;
      return (0, _utilities.calculateRem)(t);
    },
    function(e) {
      var t = e.iconWidth;
      return (0, _utilities.calculateRem)(t);
    }
  ),
  getIconSize = function(e) {
    switch (e) {
      case 'XLarge':
        return 28;
      case 'large':
        return 24;
      case 'small':
        return 16;
      case 'medium':
        return 20;
      default:
        return e || 20;
    }
  },
  Info = function(e) {
    var t = e.ariaHidden,
      a = e.ariaLabel,
      r = e.size,
      i = e.lineColor,
      l = e.color,
      o = e.surface,
      f = e.id,
      n = e.tabIndex,
      c = (e.iconName, e.viewBox, e.svgContent, i || l);
    (('dark' !== o || l || i) &&
      ('dark' !== o ||
        ('black' !== l &&
          l !== _color.ColorTokens.elements.primary.onlight.value &&
          'Black' !== l))) ||
      (c = _color.ColorTokens.elements.primary.ondark.value);
    var d = a || 'info icon';
    return _react.default.createElement(
      StyledSVG,
      {
        id: f,
        role: 'img',
        'aria-hidden': t,
        'aria-label': d,
        'alt-text': d,
        tabIndex: n,
        iconWidth: getIconSize(r),
        iconHeight: getIconSize(r),
        viewBox: '0 0 21.6 21.6',
        surface: o,
        fill: c,
      },
      !t && _react.default.createElement('title', null, d),
      _react.default.createElement('path', {
        fill: c,
        class: 'cls-1',
        d:
          'M19.8,10.8a9,9,0,1,0-9,9A9.01054,9.01054,0,0,0,19.8,10.8Zm-1.12488,0A7.87513,7.87513,0,1,1,10.8,2.92486,7.88411,7.88411,0,0,1,18.67509,10.8ZM11.625,7.45852H9.95v-1.675h1.675ZM9.95834,9.11662H11.65v6.6999H9.95834Z',
      })
    );
  };
(Info.propTypes = propTypes),
  (Info.defaultProps = defaultProps),
  (Info.displayName = 'VDS_Icon');
var _default = (exports.default = Info);
